<script>
  /**
   * @typedef {Object} Props
   * @property {any} id
   * @property {boolean} [first]
   * @property {string} [show]
   * @property {import('svelte').Snippet} [icon]
   * @property {import('svelte').Snippet} [text]
   */

  /** @type {Props} */
  let {
    id,
    first = false,
    show = $bindable(""),
    icon,
    text
  } = $props();
  function handleClick() {
    if (!window.specialistsSearchFocus) {
	  dataLayer.push({ 'event': 'formStart' });
	  window.specialistsSearchFocus = true;
	}   
  }
</script>

<style>
  :global(.wc-specialist__radiogroup__label) {
    display: flex;
    flex-direction: column;
    flex: 0 0 100%;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding: 3rem 1rem;
    background-color: transparent;
    color: #8c8c8c;
    font-size: 1.8rem;
    font-family: IrmaRegular, sans-serif;
    border-radius: 4px;
    border: none;
    box-shadow: none;
    margin: 0 10px 10px -16px;
    width: 158px;
    height: 250px;
    transition: all 300ms ease-in-out;
    cursor: pointer;
    z-index: 1;
    pointer-events: auto;
  }

  :global(.wc-specialist__radiogroup__label img) {
    pointer-events: none;
    z-index: -1;
  }

  :global(.wc-specialist__radiogroup__label p) {
    color: inherit;
    font-size: inherit;
    font-family: inherit;
    max-width: 100%;
    margin: 0;
  }

  :global(.wc-specialist__radiogroup__label:hover, .wc-specialist__radiogroup__label:focus) {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.16);
  }
  :global(.wc-specialist__radiogroup__radio:focus
      + .wc-specialist__radiogroup__label) {
    outline: 2px dashed #007497;
    outline-offset: 1px;
  }
  :global(input[type="radio"]:checked + .wc-specialist__radiogroup__label) {
    color: #333333;
    border: 4px solid #c7c7c7;
  }
</style>

<div class="flex w-[168px] relative">
  <input
    type="radio"
    {id}
    name="waterwiseCategoriesRadioList"
    value={id}
    class="outline-none invisible"
    tabindex={first ? 0 : -1}
    bind:group={show}
    onclick={handleClick} />
  <!-- svelte-ignore a11y_no_noninteractive_element_to_interactive_role -->
  <label
    for={id}
    class="wc-specialist__radiogroup__label"
    role="radio"
    aria-checked={id === show}>
    {#if icon}{@render icon()}{:else}
      <em>no icon provided</em>
    {/if}
    {#if text}{@render text()}{:else}
      <em>no description provided</em>
    {/if}
  </label>
</div>
